import { SearchSortOrder } from '#server/models';

export const researchSortOrders: SearchSortOrder[] = [
  { title: 'Relevance', type: 'relevance' },
  {
    title: 'Sort by A - Z',
    type: 'field',
    field: 'sortableTitle',
    order: 'asc',
  },
  {
    title: 'Sort by Z - A',
    type: 'field',
    field: 'sortableTitle',
    order: 'desc',
  },
];
